import { Suspense, lazy, useContext, useEffect, useCallback } from "react";
import { DiseaseContext } from "./Context/Disease";
// import { fetchDiseaseAction } from "./Context/Disease/action";
import Navigation from "./Components/Navigation";
import { Switch, Route, useLocation } from "react-router-dom";
import { ToastContainer, Slide } from "react-toastify";

import routes from "./utils/routes";
import Fallback from "./Components/Fallback";
import Footer from "./Components/Footer";
import StoryContextProvider from "./Context/Stories/context";

import Feedback from "./Feedback";
import InfographicsContextProvider from "./Context/Infographics";
import GalleryContext from "./Context/Gallery";
import ResourceContext from "./Context/Resource";
import VideoContext from "./Context/Videos";
import Home from "./Home";

// import ViewSingleBlogContainer from "./Blog/viewSingleBlog";
// import AllBlogs from "./Blog/allBlogs";
import BlogContextWrapper from "./Context/Blog/context";
// import News from "./Blog";
import FeedBackContextWrapper from "./Context/Feedback/context";
import EventContextWrapper from "./Context/Events";
import AppLoader from "./Components/AppLoader";
import { CountryContext } from "./Context/Country/context";
import { AppContext } from "./Context/App";
import { setupApplication } from "./Context/App/action";
import { DonationContext } from "./Context/Donation";
import loadScripts from "./utils/loadScripts";
import { useHistory } from "react-router-dom";
import ReactGA from "./reactGA";

const ShareYourStory = lazy(() => import("./ShareYourStory"));
const AboutUs = lazy(() => import("./About"));
const Resources = lazy(() => import("./Resources"));
const Country = lazy(() => import("./Country"));
const SingleStory = lazy(() => import("./Story/SingleStory"));
const News = lazy(() => import("./News"));
const SingleNews = lazy(() => import("./News/SingleNew"));
const SingleEvent = lazy(() => import("./Events/SingleEvent"));
const Admin = lazy(() => import("./Admin"));
const Login = lazy(() => import("./Admin/Auth/Login/Login"));
const SingleInfographics = lazy(() => import('./Resources/Infographics/SingleInfographics'));

function App() {
  const { dispatch: diseaseDispatch } = useContext(DiseaseContext);
  const { dispatch: countryDispatch } = useContext(CountryContext);
  const { dispatch: donationDispatch } = useContext(DonationContext);
  const { appState, dispatch: appDispatch } = useContext(AppContext);

  const history = useHistory();

  useEffect(() => {
    ReactGA.set({ page: history?.location.pathname });
    ReactGA.pageview(history?.location.pathname);
  }, [history?.location?.pathname]);

  useEffect(() => {
    appDispatch(
      setupApplication(countryDispatch, diseaseDispatch, donationDispatch)
    );
  }, [appDispatch, countryDispatch, diseaseDispatch, donationDispatch]);

  const onScriptLoad = useCallback(() => {
    console.log("scripts loaded");
  }, []);

  useEffect(() => {
    loadScripts(["https://apis.google.com/js/platform.js"], [onScriptLoad]);
  }, [onScriptLoad]);

  const { key } = useLocation();

  const appNav = appState?.appState?.value?.nav || {};
  return (
    <>
      <ToastContainer
        transition={Slide}
        position="top-right"
        // autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <BlogContextWrapper>
        <GalleryContext>
          <ResourceContext>
            <VideoContext>
              <EventContextWrapper>
                {appState?.settingUp && <AppLoader />}
                {!appState?.settingUp && (
                  <>
                    {" "}
                    <Route
                      exact
                      path={[
                        routes.about,
                        routes.share,
                        routes.resources,
                        `${routes.resources}/:activeTab`,
                        `${routes.resources}/story/:id`,
                        routes.feedback,
                        routes.countries,
                        routes.home,
                        routes.blogs,
                        routes.viewSingleBlog,
                        routes.news,
                        `${routes.countries}/:id`,
                        `${routes.event}/:id`,
                        `${routes.infographics}/:id`,
                      ]}
                    >
                      <Navigation appNav={appNav} />
                    </Route>
                    <StoryContextProvider>
                      <InfographicsContextProvider>
                        <FeedBackContextWrapper>
                          <div className="app__container">
                            <Suspense fallback={<Fallback />}>
                              <Switch>
                                {appNav?.about && (
                                  <Route exact path={routes.about}>
                                    <AboutUs />
                                  </Route>
                                )}
                                {appNav?.story && (
                                  <Route exact path={routes.share}>
                                    <ShareYourStory key={key} />
                                  </Route>
                                )}
                                {appNav?.country && (
                                  <Route path={`${routes.countries}/:id`}>
                                    <Country appNav={appNav} />
                                  </Route>
                                )}
                                {appNav?.feedback && (
                                  <Route
                                    exact
                                    path={routes.feedback}
                                    component={Feedback}
                                  />
                                )}
                                {appNav?.resource && (
                                  <Route exact path={`${routes.resources}/:activeTab?`}>
                                    <Resources appNav={appNav} />
                                  </Route>
                                )}
                                {appNav?.resource && (
                                  <Route path={`${routes.event}/:id`}>
                                    <SingleEvent />
                                  </Route>
                                )}
                                {appNav?.resource && (
                                  <Route path={`${routes.infographics}/:id`}>
                                    <SingleInfographics />
                                  </Route>
                                )}
                                {appNav?.story && (
                                  <Route path={`${routes.story}/:id`}>
                                    <SingleStory />
                                  </Route>
                                )}
                                {appNav?.news && (
                                  <Route path={`${routes.news}/:id`}>
                                    <SingleNews />
                                  </Route>
                                )}
                                <Route exact path={routes.home}>
                                  <Home />
                                </Route>

                                {appNav?.news && (
                                  <Route
                                    exact
                                    path={routes.news}
                                    component={News}
                                  />
                                )}
                                {/* <Route exact path={routes.viewSingleBlog}>
                                  <ViewSingleBlogContainer />
                                </Route> */}
                                <Route path={routes?.admin}>
                                  <Admin />
                                </Route>
                                <Route exact path={routes.adminLogin}>
                                  <Login />
                                </Route>
                              </Switch>
                            </Suspense>
                          </div>
                        </FeedBackContextWrapper>
                      </InfographicsContextProvider>
                    </StoryContextProvider>
                    <Route
                      exact
                      path={[
                        routes.about,
                        routes.share,
                        routes.feedback,
                        routes.resources,
                        `${routes.resources}/:activeTab`,
                        `${routes.resources}/story/:id`,
                        routes.countries,
                        routes.home,
                        routes.blogs,
                        routes.viewSingleBlog,
                        routes.news,
                        `${routes.countries}/:id`,
                        `${routes.event}/:id`,
                        `${routes.infographics}/:id`,
                      ]}
                    >
                      <Footer appNav={appNav} />
                    </Route>{" "}
                  </>
                )}
              </EventContextWrapper>
            </VideoContext>
          </ResourceContext>
        </GalleryContext>
      </BlogContextWrapper>
    </>
  );
}

export default App;
